function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgSidebarPhone(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M5.542 2.654c.156-.156.468-.078.546.078l1.56 2.263-.077.312-.859.703c-.936.702 1.561 4.214 2.576 3.668l.936-.624h.313l1.56 2.185c.157.156.079.39-.078.546-.078.078 0 .157.079.157.546.312.546 1.014.624 1.404.078.78-.39 1.405-1.249 1.873-1.092.469-2.263.781-3.512.781C3.59 16 0 12.41 0 7.961 0 3.591 3.59 0 7.96 0 12.41 0 16 3.59 16 7.961c0 1.795-.624 3.434-1.561 4.76-.39.47-1.015.079-.546-.623.858-1.171 1.326-2.576 1.326-4.137 0-3.98-3.277-7.18-7.258-7.18-3.98 0-7.18 3.2-7.18 7.18 0 3.98 3.2 7.258 7.18 7.258 1.093 0 2.03-.234 2.888-.624.624-.312 1.093-.858.936-1.249-.078-.39-.468-1.014-.78-.936-.937.234-3.044.624-5.463-2.81-2.966-3.98-1.25-6.01-.859-6.4l.859-.546z",
    fill: "#0A1633",
    fillRule: "evenodd"
  }));
}

SvgSidebarPhone.clsName = 'icon-www__sidebar_phone';
SvgSidebarPhone.remarkName = 'unknown';
export default SvgSidebarPhone;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/SidebarPhone.js
// module id = 2432
// module chunks = 17 18